import React from 'react'
import { Link  } from 'react-router-dom';
import { Button} from 'react-bootstrap';
import { Helmet } from "react-helmet-async";

const PageNotFound = () => {
    return (
        <>
        <Helmet>
            <title>Page Not Found</title>
            <meta name="description" content=" Oasis Educational Institute" />
        </Helmet>
            <div className="py-5 px-10" style={{
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 80px)',
                width: '100%',
             
            }}>
                <h1 className="fs-2 fw-bold text-capitalized">404 - Page Not Found</h1>  <br />
                <p className="fs-5">Sorry, we couldn’t find the page you’re looking for.</p>
                <div className='mt-4'>  
                <Button className='btn primary-btn btn-sm p-2 ' as={Link} to="/" >TAKE ME HOME</Button>
                <span className='ms-4'>
                <a href="mailto:info@oasissgr.in" className='btn sec-btn fs-6 '> Contact Support</a>
                </span>
                </div>
               
        
              
            </div >
        </>

    )
}

export default PageNotFound